// M5.3 — incoming party invite popup. Sits center-top with Accept / Decline
// buttons; auto-clears when TTL elapses (server times out the invite too;
// the client just hides the popup so a stale invitation can't be accepted
// after the inviter walked away).

import { el } from "./dom.js";

export interface InviteToastCallbacks {
  onAccept: () => void;
  onDecline: () => void;
}

export class InviteToast {
  readonly root: HTMLElement;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(private readonly cb: InviteToastCallbacks) {
    this.root = el("div", { class: "invite-toast hidden" });
  }

  show(args: { fromCharacterName: string; expiresAt: number }): void {
    this.clearTimer();
    this.root.replaceChildren();
    this.root.append(
      el(
        "div",
        { class: "invite-toast-text" },
        `${args.fromCharacterName} invites you to a party.`,
      ),
    );
    const accept = el("button", { class: "btn invite-toast-btn", type: "button" }, "Accept");
    const decline = el(
      "button",
      { class: "btn-ghost invite-toast-btn", type: "button" },
      "Decline",
    );
    accept.addEventListener("click", () => {
      this.hide();
      this.cb.onAccept();
    });
    decline.addEventListener("click", () => {
      this.hide();
      this.cb.onDecline();
    });
    this.root.append(el("div", { class: "invite-toast-actions" }, accept, decline));
    this.root.classList.remove("hidden");
    const remaining = Math.max(0, args.expiresAt - Date.now());
    this.timeoutId = setTimeout(() => this.hide(), remaining);
  }

  hide(): void {
    this.clearTimer();
    this.root.classList.add("hidden");
  }

  destroy(): void {
    this.clearTimer();
    this.root.remove();
  }

  private clearTimer(): void {
    if (this.timeoutId !== null) clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
}
